import { render, staticRenderFns } from "./StickerCard.vue?vue&type=template&id=83d5f0d4&scoped=true&"
import script from "./StickerCard.vue?vue&type=script&lang=ts&"
export * from "./StickerCard.vue?vue&type=script&lang=ts&"
import style0 from "./StickerCard.vue?vue&type=style&index=0&id=83d5f0d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d5f0d4",
  null
  
)

export default component.exports